// import QRCode from "react-qr-code";
import images from "../constants/images";
import mainStyle from "../styles/app.module.css";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Image from "next/image";
import dynamic from "next/dynamic";
const QRCode = dynamic(() => import("react-qr-code"), {
  ssr: false, // Don't render on server
  loading: () => (
    <div className="w-[120px] h-[120px] bg-gray-200 rounded flex items-center justify-center">
      <span className="text-gray-500 text-sm">Loading...</span>
    </div>
  ),
});

const Footer = () => {
  const pathname = usePathname();
  // if (pathname.includes("slashslash")) {
  //   return null;
  // }
  return (
    <div className="pt-[1.5rem] pb-[1.5rem] sm:pt-[2rem] sm:pb-[2rem] md:pt-[4.875rem] md:pb-[4.875rem] bottom-0 left-0 w-full bg-white text-gray-800 shadow-[0px_0px_4px_0px_rgba(131,131,131,0.25)]">
      <div className={mainStyle.container}>
        <div className="flex flex-col md:flex-row md:justify-between gap-8">
          {/* Column 1 */}
          <div className="flex flex-col items-start md:items-start">
            <div className=" mb-[0.5rem] md:mb-[2rem] ">
              <Image
                src={images.logo.src}
                alt={images.logo.alt}
                width={0}
                height={60} // Set to 0
                loading="lazy"
                className="h-[2.5rem] w-auto" // Let CSS control dimensions
                style={{ width: "auto" }} // Ensure auto height
              />
            </div>
            <p className="text-[#7D7D7D] md:text-[#0B2131] text-[clamp(0.75rem,2vw,1rem)] max-w-xs">
              Beautiful, customizable wedding invitations designed to celebrate
              every Indian tradition.
            </p>
          </div>

          {/* Column 2 - Contact Us - Hidden on mobile */}
          <div className="hidden md:flex md:flex-col md:items-start">
            <a
              href="https://www.myweddinglyinvites.com/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center mb-[1.5rem]"
            >
              <p className="text-[#071A34] text-[clamp(0.625rem,2vw,1rem)] font-[700]">
                Contact Us
              </p>
            </a>
            <a
              href="https://instagram.com/myweddinglyinvites"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center mb-[1.5rem]"
            >
              <Image
                src={images.instagram.src}
                alt="Instagram"
                width={20}
                height={20}
                loading="lazy"
                className="h-5 w-5 mr-2"
              />

              <span className="text-[#090914] text-[clamp(0.625rem,2vw,1rem)] font-[700]">
                Instagram
              </span>
            </a>
            <a
              href="https://facebook.com/myweddinglyinvites"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center mb-2 hover:text-blue-600"
            >
              <Image
                src={images.facebook.src}
                alt="Facebook"
                width={20}
                height={20}
                loading="lazy"
                className="h-5 w-5 mr-2"
              />

              <span className="text-[#090914] text-[clamp(0.625rem,2vw,1rem)] font-[700]">
                Facebook
              </span>
            </a>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col items-start">
            <details className="w-full md:hidden group">
              <summary className="flex w-full items-center justify-between py-3 list-none cursor-pointer text-[#090914] text-[0.75rem] font-bold border-b border-[#D8D8D8] mb-4">
                <span>Help</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 transform transition-transform duration-200 group-open:rotate-180"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </summary>
              <nav className="flex flex-col pb-4">
                <a href="/terms-and-conditions" className="mb-3">
                  Terms &amp; Conditions
                </a>
                <a href="/privacy-policy" className="mb-3">
                  Privacy Policy
                </a>
                <a href="/about" className="mb-3">
                  About Us
                </a>
                <a href="/contact-us">Contact Us</a>
              </nav>
            </details>

            <div className="hidden md:flex flex-col items-start">
              <p className="text-[#090914] text-[clamp(0.625rem,2vw,1rem)] font-[700] mb-[1.5rem]">
                Help
              </p>
              <Link
                href="/terms-and-conditions"
                className="text-[#090914] text-[clamp(0.625rem,2vw,1rem)] font-[700] mb-[1.5rem]"
              >
                Terms & Conditions
              </Link>
              <Link
                href="/privacy-policy"
                className="text-[#090914] text-[clamp(0.625rem,2vw,1rem)] font-[700] mb-[1.5rem]"
              >
                Privacy Policy
              </Link>
              <Link
                href="/about"
                className="text-[#090914] text-[clamp(0.625rem,2vw,1rem)] font-[700] mb-[1.5rem]"
              >
                About Us
              </Link>
              <Link
                href="/contact-us"
                className="text-[#090914] text-[clamp(0.625rem,2vw,1rem)] font-[700] mb-[1.5rem]"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Column 4 */}
          <div className="flex flex-col items-start md:items-start">
            <p className="text-[#090914] text-[clamp(0.75rem,2vw,1rem)] font-[600] md:font[700] mb-[0.25rem] md:mb-[0.5rem]">
              DOWNLOAD OUR APP
            </p>
            <p className="text-[#0B214A] text-[clamp(0.75rem,2vw,1rem)] font-[400] mb-[1rem] md:mb-[1.5rem]">
              Create stunning wedding invitations that reflect your style and
              culture{" "}
            </p>

            <div className="flex flex-wrap items-start justify-start gap-[1rem]">
              <div
                className=" hidden md:flex md:h-[11.25rem]  md:w-[11.25rem] bg-[#F6F6F6] flex-col items-center justify-center gap-[0.5rem] rounded-[0.75rem]
  "
              >
                <QRCode
                  value="https://myweddinglyinvites.com/app"
                  size={120}
                  level="H"
                />
                <p className="text-[#4D4D4D] text-[clamp(0.625rem,2vw,1rem)] font-[700]">
                  SCAN HERE
                </p>
              </div>
              <div className="flex flex-row md:flex-col justify-start gap-[0.5rem] md:gap[1rem]">
                <a
                  href="https://play.google.com/store/apps/details?id=com.myweddinglyinvites"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gap-[1rem]"
                >
                  <div
                    className="flex items-center border border-[#D9D9D9] rounded-lg p-2 gap-2"
                    style={{ width: "141px", height: "40px" }}
                  >
                    <Image
                      src={images.googlePlay.src}
                      alt={images.googlePlay.alt}
                      width={18}
                      height={18}
                      loading="lazy"
                      className="h-[1.125rem]"
                    />
                    <div className="flex flex-col padding-top-[2]">
                      <p className="text-[10px] text-[#353535] font-[700] mb-0">
                        Get it on
                      </p>
                      <p className="text-[14px] text-[#353535] font-[700] mb-0">
                        Google Play
                      </p>
                    </div>
                  </div>
                </a>
                <a
                  href="https://apps.apple.com/app/id6511243502"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div
                    className="flex items-center border border-[#D9D9D9] rounded-lg p-2"
                    style={{ width: "141px", height: "40px" }}
                  >
                    <img
                      src={images.appleStore.src}
                      alt={images.appleStore.alt}
                      className="h-[1.125rem]"
                    />
                    <div className="ml-2">
                      <p className="text-[10px] text-[#353535] font-[700] mb-0">
                        Download on the
                      </p>
                      <p className="text-[14px] text-[#353535] font-[700] mb-0">
                        App Store
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            {/* Social Icons for Mobile Only */}
            <div className="flex md:hidden mt-4 w-full justify-center gap-[1rem]">
              <a
                href="https://instagram.com/myweddinglyinvites"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="h-[1.5rem] w-[1.5rem] flex items-center justify-center rounded-md   drop-shadow-[0px_0px_0.4px_rgba(0,0,0,0.25)]">
                  <Image
                    src={images.instagram?.src || "/instagram-icon.svg"}
                    alt="Instagram"
                    width={24}
                    height={24}
                    loading="lazy"
                    className="h-[1.5rem] w-[1.5rem]"
                  />
                </div>
              </a>
              <a
                href="https://facebook.com/myweddinglyinvites"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="h-[1.5rem] w-[1.5rem] flex items-center justify-center rounded-md   drop-shadow-[0px_0px_0.4px_rgba(0,0,0,0.25)]">
                  <Image
                    src={images.facebook.src}
                    alt="Facebook"
                    width={24}
                    height={24}
                    loading="lazy"
                    className="h-[1.5rem] w-[1.5rem]"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="hidden md:block border-t border-gray-200 mt-8 pt-8 text-left md:text-center">
          <p>
            © {new Date().getFullYear()} MyWeddinglyInvites. All rights
            reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
